export const campaigntext = {
    id: "Identifiant",
    name: "Nom",
    group: "Périmètre",
    description: "Description",
    incharge: "Responsable campagne",
    status: "Statut",
    datebegin: "Date de début",
    dateend: "Date de fin",
}

export const campaignequipmenttext = {
    id: "Identifiant",
    name: "Nom",
    campaignname: "Nom pour la campagne",
    campaigngroup: "Périmètre pour la campagne",
    definition: "Type",
    installed: "Etat de pose",
    localization: "Détail de la localisation",
    status: "Statut"
}

export const campaignpointtext = {
    id: "Identifiant",
    name: "Nom du point",
    session: "Session",
    state: "Etat",
    lastdate: "Date de dernière donnée",
    lastvalue: "Dernière valeur",
    equipment: "Equipement",
    group: "Site",
    definition: "Type",
    unit: "Unité",
    conversion: "Conversion",
}

export const campaignviewtext = {
    id: "Identifiant",
    name: "Nom",
    groups: "Groupe par défaut",
    datebegin: "Date de début minimale",
    dateend: "Date de fin maximale",
    columns: "Nombre de colonnes",
    chartscount: "Nombre de graphiques",
}

export const campaigncharttext = {
    id: "Identifiant",
    name: "Nom du graphique",
    source: "Source de donnée",
    type: "Type de graphique",
    granularity: "Granularité",
    existingchart: "Graphique existant",
    point: "Point",
    definition: "Type de donnée",
    position: "Position",
    serietype: "Type",
    seriename : "Nom",
    axis: "Axe",
    valuetype: "Type de valeur",
    rightaxis: "Axe de droite",
    leftaxisunit : "Unité axe de gauche",
    rightaxisunit : "Unité axe de droite",
    defaultoccupationschedule : "Afficher par défaut le planning d'occupation",
    value: "Valeur",
}